import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { AuthedRouter } from './routes/routes';
import { theme } from './utils/theme';

import './index.css';

const Router = () => {
  const router = AuthedRouter;

  return (
    <RouterProvider
      router={router}
    />
  );
};

export const App = () => (
  <>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
    <ToastContainer />
  </>
);
